import { z } from 'zod';
export const cuid = () => z.string().min(1).max(40);
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().trim().optional(),
    sort: z.string().optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
export const paginatedResult = (item) => z.object({
    items: z.array(item),
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
});
export const errorResponse = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
export const idParam = z.object({ id: cuid() });
//# sourceMappingURL=common.js.map